module.exports = __webpack_public_path__ + "img/chef01.fd1b5ef4.png";